import { connect } from "react-redux";

import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { PathResolver, withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";

import { ErrorBlock } from "./ErrorBlock";

export interface ErrorBlockContainerProps {
    paths: AbsoluteModelPath[];
    children?: JSX.Element;
    viewModelSelect: ViewModelSelect;
    resolvePath: PathResolver;
}

const mapStateToProps = (state: FullFormState, ownProps: ErrorBlockContainerProps) => {
    const nestedErrorCount = ownProps.paths
        .map(it => ownProps.resolvePath(it))
        .filter(p => p.getIterationRank() === 0)
        .map(p => ownProps.viewModelSelect.getErrorCount(state, p))
        .reduce((acc, x) => acc + x, 0);

    return {
        hasErrors: nestedErrorCount > 0,
    };
};

export const ErrorBlockContainer = withResolvePaths(withViewModelSelect(connect(mapStateToProps)(ErrorBlock)));
